import React from "react"
import {ShowEdit} from "components/backoffice/Media/Show/ShowEdit"

export const ShowEditRoute = (props: any) => {

  return <div>
    <ShowEdit id={""} />
  </div>
}